function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>")
}

function productGridView(e) {}
var resizeTimer;
window.theme = window.theme || {}, window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(e, t) {
            var i = $(e),
                n = i.attr("data-section-id"),
                s = i.attr("data-section-type");
            if (t = t || this.constructors[s], !_.isUndefined(t)) {
                var a = _.assignIn(new t(e), {
                    id: n,
                    type: s,
                    container: e
                });
                this.instances.push(a)
            }
        },
        _onSectionLoad: function(e) {
            var t = $("[data-section-id]", e.target)[0];
            t && this._createInstance(t)
        },
        _onSectionUnload: function(e) {
            this.instances = _.filter(this.instances, function(t) {
                var i = t.id === e.detail.sectionId;
                return i && _.isFunction(t.onUnload) && t.onUnload(e), !i
            })
        },
        _onSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
        },
        _onDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
        },
        _onBlockSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
        },
        _onBlockDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
        },
        register: function(e, t) {
            this.constructors[e] = t, $("[data-section-type=" + e + "]").each(function(e, i) {
                this._createInstance(i, t)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function() {
            $(".rte table").wrap('<div class="rte__table-wrapper"></div>')
        },
        iframeReset: function() {
            var e = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                t = e.add(".rte iframe#admin_bar_iframe");
            e.each(function() {
                $(this).wrap('<div class="video-wrapper"></div>')
            }), t.each(function() {
                this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(e) {
            var t = "js-focus-hidden";
            e.first().attr("tabIndex", "-1").focus().addClass(t).one("blur", function() {
                e.first().removeClass(t).removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(e) {
                this.pageLinkFocus($(e.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(t, function(t) {
                e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
            })
        },
        removeTrapFocus: function(e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t)
        }
    }, theme.Images = function() {
        return {
            preload: function(e, t) {
                "string" == typeof e && (e = [e]);
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    this.loadImage(this.getSizedImageUrl(n, t))
                }
            },
            loadImage: function(e) {
                (new Image).src = e
            },
            switchImage: function(e, t, i) {
                var n = this.imageSize(t.src),
                    s = this.getSizedImageUrl(e.src, n);
                i ? i(s, e, t) : t.src = s
            },
            imageSize: function(e) {
                var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== t ? t[1] : null
            },
            getSizedImageUrl: function(e, t) {
                if (null == t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != i) {
                    var n = e.split(i[0]),
                        s = i[0];
                    return this.removeProtocol(n[0] + "_" + t + s)
                }
                return null
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        var e = "${{amount}}";
        return {
            formatMoney: function(t, i) {
                "string" == typeof t && (t = t.replace(".", ""));
                var n = "",
                    s = /\{\{\s*(\w+)\s*\}\}/,
                    a = i || e;

                function o(e, t, i, n) {
                    if (t = t || 2, i = i || ",", n = n || ".", isNaN(e) || null == e) return 0;
                    var s = (e = (e / 100).toFixed(t)).split(".");
                    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? n + s[1] : "")
                }
                switch (a.match(s)[1]) {
                    case "amount":
                        n = o(t, 2);
                        break;
                    case "amount_no_decimals":
                        n = o(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        n = o(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = o(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = o(t, 0, " ")
                }
                return a.replace(s, n)
            }
        }
    }(), slate.Variants = function() {
        function e(e) {
            this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _getCurrentOptions: function() {
                var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                    var t = $(e),
                        i = t.attr("type"),
                        n = {};
                    if ("radio" === i || "checkbox" === i) return !!t[0].checked && (n.value = t.val(), n.index = t.data("index"), n);
                    if (n.value = t.val(), n.index = t.data("index"), null != n.value) {
                        var s = n.value.replace(/'/g, "\\'");
                        $("." + n.index).find(".swatchInput[value='" + s + "']").prop("checked", !0), $("." + n.index).find(".slVariant").text(n.value)
                    }
                    return n
                });
                return e = _.compact(e)
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.product.variants;
                return _.find(t, function(t) {
                    return e.every(function(e) {
                        return _.isEqual(t[e.index], e.value)
                    })
                })
            },
            _onSelectChange: function() {
                var e = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: e
                }), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                if (history.replaceState && e) {
                    var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                    window.history.replaceState({
                        path: t
                    }, "", t)
                }
            },
            _updateMasterSelect: function(e) {
                $(this.originalSelectorId, this.$container).val(e.id)
            }
        }), e
    }(), window.theme = window.theme || {}, theme.Header = function() {
        var e = {
            body: "body",
            sitenav: "#siteNav",
            navLinks: "#siteNav .lvl1 > a",
            mobilenav: ".mobile-nav-wrapper",
            menuLinks: "#MobileNav .ad"
        };
        return {
            init: function() {
                $(".header-cart,.close-cart").on("click", function(e) {
                    e.preventDefault(), e.stopPropagation(), $("#cart-drawer").toggleClass("active")
                }), $(".site-settings").on("click", function() {
                    $("#settingsBox").toggleClass("active")
                }), $(e.navLinks).each(function() {
                    $(this).attr("href") == window.location.pathname && $(this).addClass("active")
                }), $(".js-mobile-nav-toggle, .closemobileMenu").on("click", function() {
                    $(e.mobilenav).toggleClass("active"), $(e.body).toggleClass("menuOn"), $(".js-mobile-nav-toggle").toggleClass("open close")
                }), $("body").click(function(t) {
                    var i = $(t.target);
                    i.parents().is(e.mobilenav) || i.parents().is(".js-mobile-nav-toggle") || i.is(".js-mobile-nav-toggle") || ($(e.mobilenav).removeClass("active"), $(e.body).removeClass("menuOn"), $(".js-mobile-nav-toggle").removeClass("close").addClass("open")), i.parents().is("#cart-drawer") || i.is("#cart-drawer") || i.parents().is(".header-cart") || i.is(".header-cart") || $("#cart-drawer").removeClass("active"), i.parents().is("#settingsBox") || i.parents().is(".site-settings") || i.is(".site-settings") || $("#settingsBox").removeClass("active")
                })
//                 , $(e.menuLinks).on("click", function(e) {
//                     e.preventDefault(), $(this).toggleClass("ad-plus-l ad-minus-l"), $(this).parent().next().slideToggle()
//                 })
            }
        }
    }(), window.theme = window.theme || {}, theme.Search = function() {
        var e = {
            search: ".search",
            searchSubmit: ".search__submit",
            searchInput: ".search__input"
        };
        return {
            init: function() {
                $(e.searchSubmit).on("click", function(t) {
                    var i = $(t.target),
                        n = i.parents(e.search).find(e.searchInput);
                    0 === n.val().length && (t.preventDefault(), searchFocus(n))
                }), $('form[action="/search"]').css("position", "relative").each(function() {
                    $(this).find('input[name="q"]').bind("keyup change", function() {
                        var e = $(this).val(),
                            t = $(this).closest("form").find(".search-results");
                        e.length > 2 ? $.getJSON("/search/suggest.json?q=" + e, {
                            resources: {
                                type: "product",
                                limit: 8,
                                options: {
                                    unavailable_products: "last",
                                    fields: "title,product_type,vendor,variants.title,variants.sku,tag"
                                }
                            }
                        }).done(function(e) {
                            var i = e.resources.results.products;
                            t.empty(), i.length > 0 ? ($.each(i, function(e, i) {
                               // i = $('<li><a href="' + i.url + '"><span class="img"><img src="' + i.featured_image.url + '" /></span><span class="details">' + i.title + '<span class="price">' + theme.Currency.formatMoney(i.price, theme.moneyFormat) + "</span></span></a></li>"), t.append(i)
                            }), theme.mlcurrency && currenciesChange(".freeShipMsg .freeShip sapn.money"), t.fadeIn(200)) : t.hide()
                        }) : t.empty().hide()
                    })
                }), $(".modalOverly, .closeSearch").bind("click", function() {
                    $("body").removeClass("showOverly"), $("#searchPopup").removeClass("active")
                }), $(".site-header .searchIco").on("click", function(e) {
                    e.stopPropagation(), $("body").addClass("showOverly"), $("#searchPopup").addClass("active"), $("input[name=q]").focus()
                })
            }
        }
    }(),
    function() {
        var e = $(".return-link");

        function t(e) {
            var t = document.createElement("a");
            return t.ref = e, t.hostname
        }
        document.referrer && e.length && window.history.length && e.one("click", function(e) {
            e.preventDefault();
            var i = t(document.referrer);
            return t(window.location.href) === i && history.back(), !1
        })
    }(), theme.Slideshow = function() {
        this.$slideshow = null;
        var e = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            currentSlide: "slick-current",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused"
        };

        function t(t) {
            this.$slideshow = $(t), this.$wrapper = this.$slideshow.closest("." + e.wrapper), this.$pause = this.$wrapper.find("." + e.pauseButton), this.settings = {
                accessibility: !0,
                arrows: this.$slideshow.data("arrow"),
                dots: this.$slideshow.data("dots"),
                fade: !0,
                rtl: theme.rtl,
                draggable: !0,
                //adaptiveHeight: true,
                touchThreshold: 20,
                autoplay: this.$slideshow.data("autoplay"),
                autoplaySpeed: this.$slideshow.data("speed")
            }, this.$slideshow.on("beforeChange", function(t, i, n, s) {
                var a = i.$slider;
                a.find("." + e.currentSlide), a.find('.slideshow__slide[data-slick-index="' + s + '"]')
            }.bind(this)), this.$slideshow.on("init", function(e, t) {
                var i = t.$slider,
                    n = t.$list,
                    s = this.$wrapper,
                    a = this.settings.autoplay;
                n.removeAttr("aria-live"), s.on("focusin", function(e) {
                    s.has(e.target).length && (n.attr("aria-live", "polite"), a && i.slick("slickPause"))
                }), t.$dots && t.$dots.on("keydown", function(e) {
                    37 === e.which && i.slick("slickPrev"), 39 === e.which && i.slick("slickNext"), 37 !== e.which && 39 !== e.which || t.$dots.find(".slick-active button").focus()
                })
            }.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this.togglePause.bind(this))
        }
        return t.prototype.togglePause = function() {
            var t = "#Slideshow-" + this.$pause.data("id");
            this.$pause.hasClass(e.isPaused) ? (this.$pause.removeClass(e.isPaused), $(t).slick("slickPlay")) : (this.$pause.addClass(e.isPaused), $(t).slick("slickPause"))
        }, t
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        function e() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
        }
        return {
            init: function() {
                var t;
                "#recover" === window.location.hash && e(), $("#RecoverPassword").on("click", function(t) {
                    t.preventDefault(), e()
                }), $("#HideRecoverPasswordLink").on("click", function(t) {
                    t.preventDefault(), e()
                }), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"), (t = $("#AddressNewForm")).length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                    hideElement: "AddressProvinceContainerNew"
                }), $(".address-country-option").each(function() {
                    var e = $(this).data("form-id"),
                        t = "AddressCountry_" + e,
                        i = "AddressProvince_" + e,
                        n = "AddressProvinceContainer_" + e;
                    new Shopify.CountryProvinceSelector(t, i, {
                        hideElement: n
                    })
                }), $(".address-new-toggle").on("click", function() {
                    t.toggleClass("hide")
                }), $(".address-edit-toggle").on("click", function() {
                    var e = $(this).data("form-id");
                    $("#EditAddress_" + e).toggleClass("hide")
                }), $(".address-delete").on("click", function() {
                    var e = $(this),
                        t = e.data("form-id"),
                        i = e.data("confirm-message");
                    confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                }))
            }
        }
    }(), window.theme = window.theme || {}, theme.HeaderSection = function() {
        function e() {
            theme.Header.init(), theme.Search.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onUnload: function() {
                theme.Header.unload()
            }
        }), e
    }(), theme.Maps = function() {
        var e = 14,
            t = null,
            i = [],
            n = theme.mapKey ? theme.mapKey : "";

        function s(e) {
            this.$container = $(e), "loaded" === t ? this.createMap() : (i.push(this), "loading" !== t && (t = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function() {
                t = "loaded", $.each(i, function(e, t) {
                    t.createMap()
                })
            })))
        }
        return s.prototype = _.assignIn({}, s.prototype, {
            createMap: function() {
                var t = this.$container.find(".map-section__container");
                return function(e) {
                    var t = $.Deferred(),
                        i = new google.maps.Geocoder,
                        n = e.data("address-setting");
                    return i.geocode({
                        address: n
                    }, function(e, i) {
                        i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e)
                    }), t
                }(t).then(function(i) {
                    var n = {
                            zoom: e,
                            center: i[0].geometry.location,
                            disableDefaultUI: !0
                        },
                        s = this.map = new google.maps.Map(t[0], n);
                    this.center = s.getCenter(), new google.maps.Marker({
                        map: s,
                        position: s.getCenter()
                    });
                    google.maps.event.addDomListener(window, "resize")
                }.bind(this)).fail(function() {
                    var e;
                    switch (status) {
                        case "ZERO_RESULTS":
                            e = theme.strings.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            e = theme.strings.addressQueryLimit;
                            break;
                        default:
                            e = theme.strings.addressError
                    }
                    t.parent().addClass("page-width map-section--load-error").html('<div class="errors text-center">' + e + "</div>")
                })
            },
            onUnload: function() {
                google.maps.event.clearListeners(this.map, "resize")
            }
        }), s
    }(), theme.Product = function() {
        function e(e) {
            this.container = e;
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                bpSmall: !1,
                enableHistoryState: t.data("enable-history-state") || !1,
                imageSize: null,
                imageZoomSize: null,
                namespace: ".slideshow-" + i,
                sectionId: i,
                sliderActive: !1,
                zoomEnabled: !1
            }, this.selectors = {
                addToCart: "#AddToCart-" + i,
                addToCartText: "#AddToCartText-" + i,
                comparePrice: "#ComparePrice-" + i,
                originalPrice: "#ProductPrice-" + i,
                saveAmount: "#SaveAmount-" + i,
                discountBadge: ".discount-badge",
                SKU: ".variant-sku",
                originalPriceWrapper: ".product-price__price-" + i,
                originalSelectorId: "#ProductSelect-" + i,
                productFeaturedImage: ".FeaturedImage-" + i,
                productImageWrap: ".FeaturedImageZoom-" + i + ".slick-active",
                productPrices: ".product-single__price-" + i,
                productThumbImages: ".product-single__thumbnail--" + i,
                productThumbs: ".product-single__thumbnails-" + i,
                saleClasses: "product-price__sale",
                saleLabel: ".product-price__sale-label-" + i,
                singleOptionSelector: ".single-option-selector-" + i,
                productMediaWrapper: "[data-product-single-media-wrapper]",
                productMediaTypeModel: "[data-product-media-type-model]"
            }, $(".mfp-link").magnificPopup({
                delegate: ".mfp",
                removalDelay: 300,
                callbacks: {
                    beforeOpen: function() {
                        $(".stickyHeader").addClass("popup"), this.st.mainClass = this.st.el.attr("data-effect")
                    },
                    close: function() {
                        $(".stickyHeader").removeClass("popup")
                    }
                },
                midClick: !0
            });
            var n = this.tabs = "#ProductSection-" + i + " .tablink";
            $(n).on("click", function(e) {
                e.preventDefault(), $(this).parent().addClass("active"), $(this).parent().siblings().removeClass("active");
                var t = $(this).attr("href");
                if ($(".tab-content").not(t).css("display", "none"), $(t).fadeIn(), $(window).width() < 767) {
                    var i = $(this).offset();
                    $("html, body").animate({
                        scrollTop: i.top
                    }, 500)
                }
            }), $(".product-tabs li:first-child").addClass("active"), $(".tab-container h3:first-child").addClass("active"), $(".tab-container h3:first-child + .tab-content").show(), $(".reviewLink, .moredetail a").on("click", function(e) {
                e.preventDefault();
                var t = $(this).attr("href");
                $(".product-tabs li").removeClass("active"), $(".tablink[href='" + t + "']").parent().addClass("active"), $(".tab-content").not(t).css("display", "none"), $(t).fadeIn();
                var i = $(t).offset();
                $(window).width() < 767 ? $("html, body").animate({
                    scrollTop: i.top - 100
                }, 700) : $("html, body").animate({
                    scrollTop: i.top - 150
                }, 700)
            }), $(".stickyOptions .selectedOpt").on("click", function() {
                $(".stickyOptions ul").slideToggle("fast")
            }), $(".stickyOptions .vrOpt").on("click", function(e) {
                var t = $(this).attr("data-val"),
                    n = $(this).attr("data-no"),
                    s = $(this).text();
                $(".selectedOpt").text(s), $(".stickyCart .selectbox").val(t).trigger("change"), $(".stickyOptions ul").slideUp("fast"), this.productvariants = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), $(".stickyCart .product-featured-img").attr("src", this.productvariants.variants[n].featured_image.src.replace(/(\.[^\.]*$|$)/, "_60x60$&"))
            }), "undefined" != typeof variantImages && $(this.selectors.productThumbImages).bind("click", function() {
                var e = $(this).attr("href").split("?")[0].split("."),
                    t = e.pop(),
                    i = e.pop().replace(/_[a-zA-Z0-9@]+$/, ""),
                    n = e.join(".") + "." + i + "." + t;
                void 0 !== variantImages[n] && productOptions.forEach(function(e, t) {
                    optionValue = variantImages[n]["option-" + t], null !== optionValue && $(".single-option-selector:eq(" + t + ") option").filter(function() {
                        return $(this).text() === optionValue
                    }).length && ($(".swatch-" + t).find('.swatchInput[value="' + optionValue + '"]').prop("checked", !0), $(".single-option-selector:eq(" + t + ")").val(optionValue).trigger("change"))
                })
            }), $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass("js-zoom-enabled"), this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr("src")), this._initBreakpoints(), this._stringOverrides(), this._initVariants(), this._initImageSwitch(), this._initThumbnailSlider(), this._setActiveThumbnail(), this._initModelViewerLibraries(), this._initShopifyXrLaunch(), theme.Images.preload(this.productSingleObject.images, this.settings.imageSize))
        }

        function t(e) {
            $(e).each(function() {
                var e = $(this).data("zoom");
                $(this).zoom({
                    url: e
                })
            })
        }

        function i(e) {
            $(e).each(function() {
                $(this).trigger("zoom.destroy")
            })
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _stringOverrides: function() {
                theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
            },
            _initBreakpoints: function() {
                var e = this;
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {
                        e.settings.zoomEnabled && i($(e.selectors.productImageWrap)), e.settings.bpSmall = !0
                    },
                    unmatch: function() {
                        e.settings.bpSmall = !1
                    }
                }), enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.zoomEnabled && t($(e.selectors.productImageWrap))
                    }
                })
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _initImageSwitch: function() {
                if ($(this.selectors.productThumbImages).length) {
                    var e = this;
                    $(this.selectors.productThumbImages).on("click", function(t) {
                        t.preventDefault();
                        var i = $(this),
                            n = i.attr("href"),
                            s = i.data("zoom");
                        e._setActiveThumbnail(n), e._switchImage(n, s)
                    })
                }
            },
            _switchImage: function(e, n) {
                if ($(".index-section--featured-product").length || $(".custom__item-inner .ptContainer").length) {
                    $(this.selectors.productImageWrap + '[data-zoom="' + n + '"]').data("slide");
                    $(this.selectors.productFeaturedImage).attr("src", e), this.settings.zoomEnabled && i($(this.selectors.productImageWrap)), !this.settings.bpSmall && this.settings.zoomEnabled && n && ($(this.selectors.productImageWrap).data("zoom", n), t($(this.selectors.productImageWrap)))
                }
            },
            _setActiveThumbnail: function(e) {
                void 0 === e && (e = $(this.selectors.productThumbImages + ".activeSlide").attr("href"));
                var t = $(this.selectors.productThumbImages + '[href="' + e + '"]');
                $(this.selectors.productThumbImages).removeClass("active-thumb"), t.addClass("active-thumb");
                var i = t.parent().data("slide");
                if ("style4" == theme.productStrings.prStyle || "style5" == theme.productStrings.prStyle) {
                    var n = $(".product-single__photo[data-slide='" + i + "']").offset();
                    $(window).width() > 767 ? $("html, body").animate({
                        scrollTop: n.top - 70
                    }, 700) : $(".primgSlider").slick("slickGoTo", i)
                } else $(".primgSlider").slick("slickGoTo", i)
            },
            _initThumbnailSlider: function() {
                $(this.selectors.productThumbs).slick(), $(".primgSlider").slick(), "style4" != theme.productStrings.prStyle && "style5" != theme.productStrings.prStyle || ($(".primgSlider").slick("unslick"), $(window).on("load resize", function() {
                    $(window).width() > 767 ? $(".primgSlider").slick("unslick") : $(".primgSlider").slick("refresh")
                })), $(window).on("load", function(e) {
                    $('.product-single__thumbnails-item[data-slide="0"] .prvideo').trigger("click");
                    var t = $(".primgSlider .videoSlide.slick-active video").get(0);
                    $(t).length && t.play()
                });
                var e = this.selectors.productImageWrap,
                    n = !this.settings.bpSmall && this.settings.zoomEnabled;
                n && (i(e), t(e)), $(".primgSlider").on("afterChange", function(s, a, o) {
                    n && (i(e), t(e)), $(".primgSlider .videoSlide video").length && $(".primgSlider .videoSlide video").get(0).pause();
                    var r = $(".primgSlider .videoSlide.slick-active video").get(0);
                    $(r).length && r.play(), $(".slick-current model-viewer").length && $(".slick-current .shopify-model-viewer-ui__button--poster").trigger("click")
                })
            },
            _initModelViewerLibraries: function() {
                var e = this.container.querySelectorAll(this.selectors.productMediaTypeModel);
                e.length < 1 || theme.ProductModel.init(e, this.settings.sectionId)
            },
            _initShopifyXrLaunch: function() {},
            _initShopifyXrLaunchHandler: function() {
                this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")").dispatchEvent(new CustomEvent("xrLaunch", {
                    bubbles: !0,
                    cancelable: !0
                }))
            },
            _updateAddToCart: function(e) {
                var t = e.variant;
                if (t)
                    if ($(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true"), null != t.unit_price ? ($("[data-unit-price]").html(theme.Currency.formatMoney(t.unit_price, theme.moneyFormat)), $("[data-unit-base]").html(t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit), $(".price__unit").removeClass("hide")) : $(".price__unit").addClass("hide"), t.available) {
                        var i = $("#pvr-" + t.id).text(),
                            n = $("#quantity_message").data("qty");
                        $(this.selectors.addToCart).prop("disabled", !1), i < 1 && "shopify" == t.inventory_management ? $(this.selectors.addToCartText).text(theme.strings.preOrder) : $(this.selectors.addToCartText).text(theme.strings.addToCart), i < 1 && "shopify" == t.inventory_management ? $(".stockLbl").removeClass("instock outstock").addClass("preorder").text($(".stockLbl").data("pre")) : $(".stockLbl").removeClass("preorder outstock").addClass("instock").text($(".stockLbl").data("in")), i < n && 0 != i && "shopify" == t.inventory_management ? $("#quantity_message").show().find(".items").text(i) : $("#quantity_message").hide()
                    } else $(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut), $(".stockLbl").removeClass("preorder instock").addClass("outstock").text($(".stockLbl").data("out")), $("#quantity_message").hide();
                else $(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.productPrices).addClass("visibility-hidden").attr("aria-hidden", "false"), $(".stockLbl").removeClass("preorder instock").addClass("outstock").text($(".stockLbl").data("out")), $("#quantity_message").hide()
            },
            _updateImages: function(e) {
                var t, i = e.variant,
                    n = theme.Images.getSizedImageUrl(i.featured_media.preview_image.src, this.settings.imageSize);
                this._setActiveThumbnail(n), this.settings.zoomEnabled && (t = theme.Images.getSizedImageUrl(i.featured_media.preview_image.src, this.settings.imageZoomSize)), this._switchImage(n, t)
            },
            _updatePrice: function(e) {
                var t = e.variant;
                if ($(this.selectors.originalPrice).html(theme.Currency.formatMoney(t.price, theme.moneyFormat)), t.compare_at_price > t.price) {
                    $(this.selectors.comparePrice).html(theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)).removeClass("hide"), $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses), $(this.selectors.saleLabel).removeClass("hide");
                    var i = t.compare_at_price - t.price,
                        n = 100 * i / t.compare_at_price;
                    $(this.selectors.discountBadge).find(".off").find("span").text(+n.toFixed()), $(this.selectors.discountBadge).removeClass("hide"), $(this.selectors.saveAmount).html(theme.Currency.formatMoney(i, theme.moneyFormat))
                } else $(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleLabel).addClass("hide"), $(this.selectors.discountBadge).addClass("hide"), $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses)
            },
            _updateSKU: function(e) {
                var t = e.variant;
                $(this.selectors.SKU).html(t.sku)
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.ProductModel = function() {
        var e = {},
            t = {},
            i = {},
            n = {
                mediaGroup: "[data-product-single-media-group]",
                xrButton: "[data-shopify-xr]"
            };

        function s(t) {
            if (!t)
                if (window.ShopifyXR) {
                    for (var i in e)
                        if (e.hasOwnProperty(i)) {
                            var n = e[i];
                            if (n.loaded) continue;
                            var a = document.querySelector("#ModelJson-" + i);
                            window.ShopifyXR.addModels(JSON.parse(a.innerHTML)), n.loaded = !0
                        } window.ShopifyXR.setupXRElements()
                } else document.addEventListener("shopify_xr_initialized", function() {
                    s()
                })
        }

        function a(e) {
            if (!e)
                for (var i in t)
                    if (t.hasOwnProperty(i)) {
                        var n = t[i];
                        n.modelViewerUi || (n.modelViewerUi = new Shopify.ModelViewerUI(n.element))
                    }
        }
        return {
            init: function(o, r) {
                e[r] = {
                    loaded: !1
                }, o.forEach(function(e, s) {
                    var a = e.getAttribute("data-media-id"),
                        o = e.querySelector("model-viewer"),
                        c = o.getAttribute("data-model-id");
                    if (0 === s) {
                        var l = e.closest(n.mediaGroup).querySelector(n.xrButton);
                        i[r] = {
                            element: l,
                            defaultId: c
                        }
                    }
                    t[a] = {
                        modelId: c,
                        sectionId: r,
                        container: e,
                        element: o
                    }
                }), window.Shopify.loadFeatures([{
                    name: "shopify-xr",
                    version: "1.0",
                    onLoad: s
                }, {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: a
                }]), theme.LibraryLoader.load("modelViewerUiStyles")
            },
            removeSectionModels: function(i) {
                for (var n in t) t.hasOwnProperty(n) && t[n].sectionId === i && (t[n].modelViewerUi.destroy(), delete t[n]);
                delete e[i]
            }
        }
    }(), theme.LibraryLoader = function() {
        var e = {
                link: "link",
                script: "script"
            },
            t = {
                requested: "requested",
                loaded: "loaded"
            },
            i = {
                modelViewerUiStyles: {
                    tagId: "shopify-model-viewer-ui-styles",
                    src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                    type: e.link
                }
            };
        return {
            load: function(n, s) {
                var a = i[n];
                if (a && a.status !== t.requested)
                    if (s = s || function() {}, a.status !== t.loaded) {
                        var o;
                        switch (a.status = t.requested, a.type) {
                            case e.script:
                                o = function(e, i) {
                                    var n = document.createElement("script");
                                    return n.src = e.src, n.addEventListener("load", function() {
                                        e.status = t.loaded, i()
                                    }), n
                                }(a, s);
                                break;
                            case e.link:
                                o = function(e, i) {
                                    var n = document.createElement("link");
                                    return n.href = e.src, n.rel = "stylesheet", n.type = "text/css", n.addEventListener("load", function() {
                                        e.status = t.loaded, i()
                                    }), n
                                }(a, s)
                        }
                        o.id = a.tagId, a.element = o;
                        var r = document.getElementsByTagName(a.type)[0];
                        r.parentNode.insertBefore(o, r)
                    } else s()
            }
        }
    }(), theme.QuickView = void $("body").on("click", ".quick-view", function(e) {
        $.ajax({
            beforeSend: function() {
                $("body").addClass("loading")
            },
            url: $(this).attr("href"),
            success: function(e) {
                $.magnificPopup.open({
                    items: {
                        src: '<div class="quick-view-popup mfpbox mfp-with-anim" id="content_quickview">' + e + "</div>",
                        type: "inline"
                    },
                    removalDelay: 500,
                    callbacks: {
                        beforeOpen: function() {
                            $(".stickyHeader").addClass("popup"), this.st.mainClass = "mfp-zoom-in"
                        },
                        open: function() {
                            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js")
                        },
                        close: function() {
                            $(".stickyHeader").removeClass("popup"), $("#content_quickview").empty()
                        }
                    }
                })
            },
            complete: function() {
                $("body").removeClass("loading")
            }
        }), e.preventDefault(), e.stopPropagation()
    }), theme.Quotes = function() {
        var e = {
                mediaQuerySmall: "screen and (max-width: 749px)",
                mediaQueryMediumUp: "screen and (min-width: 750px)",
                slideCount: 0
            },
            t = {
                accessibility: !0,
                arrows: !0,
                dots: !1,
                autoplay: !1,
                touchThreshold: 20,
                rtl: theme.rtl,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: !0
            };

        function i(i) {
            var n = (this.$container = $(i)).attr("data-section-id"),
                s = this.wrapper = ".quotes-wrapper",
                a = this.slider = "#Quotes-" + n,
                o = $(a, s),
                r = !1;
            e.slideCount = o.data("count"), e.slideCount < t.slidesToShow && (t.slidesToShow = e.slideCount, t.slidesToScroll = e.slideCount), o.on("init", this.a11y.bind(this)),
                function(e, t) {
                    r && (e.slick("unslick"), r = !1);
                    e.slick(t), r = !0
                }(o, t)
        }
        return i.prototype = _.assignIn({}, i.prototype, {
            onUnload: function() {
                enquire.unregister(e.mediaQuerySmall), enquire.unregister(e.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick")
            },
            onBlockSelect: function(e) {
                var t = $(".quotes-slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                $(this.slider, this.wrapper).slick("slickGoTo", t)
            },
            a11y: function(e, t) {
                var i = t.$list,
                    n = $(this.wrapper, this.$container);
                i.removeAttr("aria-live"), n.on("focusin", function(e) {
                    n.has(e.target).length && i.attr("aria-live", "polite")
                }), n.on("focusout", function(e) {
                    n.has(e.target).length && i.removeAttr("aria-live")
                })
            }
        }), i
    }(), theme.slideshows = {}, theme.SlideshowSection = function() {
        return function(e) {
            var t = (this.$container = $(e)).attr("data-section-id"),
                i = this.slideshow = "#Slideshow-" + t;
            $(i).each(function() {
                $(this)
            }), theme.slideshows[i] = new theme.Slideshow(i)
        }
    }(), theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
        onUnload: function() {
            delete theme.slideshows[this.slideshow]
        },
        onBlockSelect: function(e) {
            var t = $(this.slideshow),
                i = $(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            t.slick("slickGoTo", i).slick("slickPause")
        },
        onBlockDeselect: function() {
            $(this.slideshow).slick("slickPlay")
        }
    }), theme.collectionView = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            t.attr("data-section-timeout"), $(document).on("change", "#SortBySt", function(e) {
                var t = $(this).val();
                $("#SortBy").val(t).trigger("change")
            }), $(document).on("click", ".change-view", function(e) {
                var t = $(this).data("view"),
                    i = document.URL.split("?"),
                    n = location.search.split("view=");
                "?" == n[0] ? window.location = i[0] + "?view=" + t : "list" == n[1] || "grid" == n[1] ? window.location = i[0] + n[0] + "view=" + t : window.location = i + "?view=" + t
            }), $(document).on("change", ".flForm .custCheck, .prRange, #SortBy", function(e) {
                var t = "//" + window.location.hostname + window.location.pathname,
                    i = $("#CollectionFiltersForm").serialize();
                ajaxfilter(t + "?" + i)
            }), $(document).on("click", ".actFilter", function(e) {
                e.preventDefault();
                var t = "//" + window.location.hostname + $(this).attr("href");
                ajaxfilter(t)
            }), ajaxfilter = function(e) {
                $.ajax({
                    type: "GET",
                    url: e,
                    data: {},
                    beforeSend: function() {
                        $("body").addClass("loading hideOverly")
                    },
                    complete: function(t) {
                        $(".productList .grid-products").html($(".productList .grid-products", t.responseText).html()), $(".filters-toolbar__product-count").html($(".filters-toolbar__product-count", t.responseText).html()), $("#CollectionFiltersForm").html($("#CollectionFiltersForm", t.responseText).html()), $(".active-facets").html($(".active-facets", t.responseText).html()), $(".pagination").html($(".pagination", t.responseText).html()), $(".pagination", t.responseText).html() ? $(".pagination").show() : $(".pagination").hide(), $(".infinitpaginOuter").html($(".infinitpaginOuter", t.responseText).html()), $(".infinitpaginOuter", t.responseText).html() || $(".infinitpagin").remove(), theme.mlcurrency && currenciesChange("sapn.money"), $("body").removeClass("loading hideOverly"), loadMoreBtn(), $(".spr-badge").length > 0 && $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js"), productGridView(i), setTimeout(function() {
                            productGridView(i)
                        }, 1e3), priceSlider(), history.pushState({
                            page: e
                        }, e, e)
                    }
                })
            }, infiniteScroll = function() {
                var e = "scroll load delayed-resize";
                $(window).on(e, function() {
                    var t = $(".infinitpagin a").attr("href");
                    if ($(".infinitpagin a.infinite").length) {
                        var i = $(".infinitpagin").offset();
                        $(document).scrollTop() + $(window).height() - 50 > i.top && ($(window).off(e), loadMore(t))
                    }
                })
            }, loadMoreBtn = function() {
                $(".infinitpagin a.loadMore").click(function(e) {
                    e.preventDefault();
                    var t = $(this).attr("href");
                    loadMore(t)
                })
            }, loadMore = function(e) {
                e.length && $.ajax({
                    type: "GET",
                    dataType: "html",
                    url: e,
                    beforeSend: function() {
                        "button" == $(".infinitpaginOuter").attr("data-type") ? $("body").addClass("loading hideOverly") : $(".infinitpagin a").show()
                    },
                    complete: function(e) {
                        $(".productList .grid-products").length ? $(".productList .grid-products").append($(".productList .grid-products", e.responseText).html()) : $(".productList .list-view-items").append($(".productList .list-view-items", e.responseText).html()), $(".infinitpagin", e.responseText).html() ? $(".infinitpagin").html($(".infinitpagin", e.responseText).html()) : $(".infinitpagin").remove(), theme.mlcurrency && currenciesChange("sapn.money"), productGridView(i), $(".spr-badge").length > 0 && $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js"), setTimeout(function() {
                            productGridView(i)
                        }, 1e3), $(".infinitpagin a.loadMore").length ? loadMoreBtn() : infiniteScroll(), $("body").removeClass("loading hideOverly")
                    }
                })
            }, $(document).ready(function() {
                infiniteScroll(), loadMoreBtn(), $("#collection-slideshow, #sideProdSlider").slick()
            })
        }
    }(), theme.instagram = {}, theme.instagramSection = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id"),
                n = t.attr("data-act"),
                s = t.attr("data-count"),
                a = t.attr("data-ds"),
                o = t.attr("data-tb"),
                r = t.attr("data-mb"),
                c = "https://graph.instagram.com/me/media?fields=comments_count,like_count,id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" + n;
            $.ajax({
                url: c,
                type: "GET",
                dataType: "json",
                success: function(e) {
                    var t = e.data,
                        n = "#instafeed" + i,
                        c = "";
                    $.each(t, function(e, t) {
                        if (e >= s) return 0;
                        var i = t.thumbnail_url || t.media_url;
                        c += '<div class="insta-img ' + a + " " + o + " " + r + '"><a rel="nofollow" class="instagram-" href="' + t.permalink + '" target="_blank"><img data-src="' + i + '" alt="" class="lazyload" /></a></div>'
                    }), $(n).html(c), $("#instafeed" + i + ".carousel").slick()
                }
            })
        }
    }(), theme.carousel = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id"),
                n = $(t).find(".carousel"),
                s = this.tabs = "#" + i + " .tablink",
                a = this.tabcontent = "#" + i + " .tab-content";
            if ($(s).on("click", function(e) {
                    e.preventDefault(), $(this).parent().addClass("active"), $(this).parent().siblings().removeClass("active");
                    var t = $(this).attr("href");
                    $(a).not(t).css("display", "none"), $(t).fadeIn(), $(n).slick("refresh"), productGridView(i + " " + t)
                }), $("#" + i).each(function() {
                    $(this).find(".collection-tabs li:first-child").addClass("active"), $(this).find(".tab-container .acor-ttl:first-child").addClass("active"), $(this).find(".tab-container h3:first-child + .tab-content").show(), $(this).find(".collection-tabs li:first-child a").attr("href")
                }), "recently-viewed" == i) {
                var o = t.attr("data-pr");
                $.ajax({
                    url: "/pages/recently-viewed-products/" + $.cookie("recentproducts") + "__pr=" + o,
                    dataType: "html",
                    type: "GET",
                    success: function(e) {
                        $(e).find(".grid-view_image").length && $("#productSlider-recently-viewed").html(e)
                    },
                    error: function(e) {
                        console.log("ajax error")
                    },
                    complete: function() {
                        $(n).slick("refresh"), productGridView(i), setTimeout(function() {
                            productGridView(i)
                        }, 1500), theme.mlcurrency && currenciesChange("#productSlider-recently-viewed span.money")
                    }
                })
            }
            if ($("#" + i + ".recommended").length) {
                var r = t.data("baseUrl"),
                    c = t.data("productId"),
                    l = r + "?section_id=product-recommendations&limit=" + t.data("limit") + "&product_id=" + c + " .product-recommendations";
                t.parent().load(l), $("#productSlider-product-recommendations").slick(), setTimeout(function() {
                    $("#productSlider-product-recommendations").slick()
                }, 1500)
            }
            $(n).slick(), productGridView(i), setTimeout(function() {
                productGridView(i)
            }, 1500), $(window).on("delayed-resize", function(e, t) {
                productGridView(i)
            })
        }
    }(), theme.masonary = function() {
        return function(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id"),
                n = this.masonary = $(t).find(".grid-masonary");

            function s(e) {
                $(e).masonry({
                    columnWidth: ".grid-sizer-" + i,
                    itemSelector: ".ms-item",
                    percentPosition: !0
                })
            }
            s(n), setTimeout(function() {
                s(n)
            }, 1e3)
        }
    }(), theme.ajaxCart = function() {
        var e;

        function t(e, t, i) {
            $("body").addClass("loading"), CartJS.addItem(e, t, i, {
                success: function(e, t, i) {
                    setTimeout(function() {
                        $("body").removeClass("loading showOverly"), $(".block-cart").addClass("active")
                    }, 1e3), drawerTimeout = setTimeout(function() {
                        $(".block-cart").removeClass("active")
                    }, 7e3)
                },
                error: function(e, t, i) {
                    var n = JSON.parse(e.responseText).description;
                    $("body").removeClass("loading"), $(".error-message").text(n), $("body").addClass("showOverly"), $("#errorDrawer").fadeIn(500), drawerTimeout = setTimeout(function() {
                        $("body").removeClass("loading showOverly"), $("#errorDrawer").fadeOut(200)
                    }, 6e3)
                }
            })
        }

        function i() {
            var e = $(".freeShipMsg").attr("data-price") - CartJS.cart.total_price;
            e > 0 ? ($(".freeShipMsg .freeShip").html(theme.Currency.formatMoney(e, theme.moneyFormat)), $(".freeShipMsg").removeClass("hide"), $(".freeShipclaim").addClass("hide"), theme.mlcurrency && currenciesChange(".freeShipMsg .freeShip sapn.money")) : ($(".freeShipMsg").addClass("hide"), $(".freeShipclaim").removeClass("hide"))
        }

        function n() {
            try {
                if (null != $.cookie("wishlistList") && "__" != $.cookie("wishlistList") && "" != $.cookie("wishlistList"))
                    for (var e = String($.cookie("wishlistList")).split("__"), t = 0; t < e.length; t++) "" != e[t] && ($('.wishlist[rel="' + e[t] + '"]').removeClass("addto-wishlist").find("span").text("Remove From Wishlist"), $('.wishlist[rel="' + e[t] + '"] .ad').removeClass("ad-heart-l").addClass("ad-heart"), $(".favCount").text(t).removeClass("hide"))
            } catch (e) {}
        }
        $(document).on("click touch", ".quickShop", function(e) {
            e.preventDefault(), e.stopImmediatePropagation();
            var t = $(this).attr("href"),
                i = $(this).parents(".grid-view-item").find(".grid-view_image"),
                n = $(this).parents(".grid-view-item").find(".shopWrapper");
            $.ajax({
                url: t,
                dataType: "html",
                type: "GET",
                beforeSend: function() {
                    $(i).append("<i class='ad ad-spinner4 ad-spin'></i>"), $(i).addClass("showLoading")
                },
                success: function(e) {
                    $(".shopWrapper").removeClass("active").html(""), $(n).addClass("active").html(e)
                },
                complete: function(e) {
                    $(i).removeClass("showLoading"), $(i).find(".ad-spinner4").remove(), theme.mlcurrency && currenciesChange(".shopWrapper.active .product-single__price span.money")
                }
            })
        }), $(document).on("click touch", ".closeShop", function(e) {
            e.preventDefault(), $(this).parents(".shopWrapper").removeClass("active")
        }), $(document).on("click touch", ".add-to-cart", function(e) {
            if (e.preventDefault(), e.stopImmediatePropagation(), theme.ajax_cart) {
                var i = $(this).attr("id"),
                    n = $(this).attr("rel");
                t(i, n)
            } else $(this).next().submit()
        }), theme.ajax_cart && $(document).on("click touchend", ".product-form__cart-submit", function(i) {
            if (i.preventDefault(), "disabled" != $(this).attr("disabled") && 1 != e) {
                var n = $(this).closest("form").find("select[name=id]").val();
                n || (n = $(this).closest("form").find("input[name=id]").val());
                var s = $(this).closest("form").find("input[name=quantity]").val();
                s || (s = 1);
                var a = {};
                $('[name="selling_plan"]').each(function() {
                    var e = $(this).attr("name"),
                        t = $(this).val();
                    a[e] = t
                }), $('[name*="properties"]').each(function() {
                    var e = $(this).attr("name").split("[")[1].split("]")[0],
                        t = $(this).val();
                    a[e] = t
                }), t(n, s, a)
            }
        }).on("touchmove", function(t) {
            e = !0
        }).on("touchstart", function() {
            e = !1
        }), $(document).on("click", ".addto-wishlist", function(e) {
            e.preventDefault();
            var t = $(this).attr("rel");
            if (null == $.cookie("wishlistList")) var i = "__" + t;
            else if (-1 == $.cookie("wishlistList").indexOf(t)) {
                var i = $.cookie("wishlistList") + "__" + t;
                i = i.replace("____", "__")
            }
            $.cookie("wishlistList", i, {
                expires: 30,
                path: "/"
            }), $(this).find(".ad").removeClass("ad-heart-l").addClass("ad-circle-notch-r ad-spin"), setTimeout(function() {
                $('.wishlist[rel="' + t + '"]').removeClass("addto-wishlist").find("span").text(theme.wlAvailable), $('.wishlist[rel="' + t + '"] .ad').removeClass("ad-circle-notch-r ad-spin").addClass("ad-heart"), n()
            }, 2e3)
        }), n(), i(), $(".continue-shopping, .modalOverly, .closeDrawer").click(function() {
            $(".modal").fadeOut(200), $("body").removeClass("loading showOverly")
        }), $(document).on("cart.requestComplete", function(e, t) {
            theme.mlcurrency && currenciesChange("#cart-drawer sapn.money"), setTimeout(function() {
                i()
            }, 3e3)
        })
    }, window.addEventListener("DOMContentLoaded", function() {
        $(theme.ajaxCart)
    }), $(document).ready(function() {
        var e = new theme.Sections;
        e.register("header-section", theme.HeaderSection), e.register("product", theme.Product), e.register("collection-template", theme.collectionView), e.register("product-template", theme.Product), e.register("map", theme.Maps), e.register("slideshow-section", theme.SlideshowSection), e.register("carousel", theme.carousel), e.register("quotes", theme.Quotes), e.register("masonary", theme.masonary), e.register("instagram", theme.instagramSection)
    }), $(window).resize(function() {
        clearTimeout(resizeTimer), resizeTimer = setTimeout(function() {
            $(window).trigger("delayed-resize")
        }, 250)
    }), theme.init = function() {
        theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(e) {
            slate.a11y.pageLinkFocus($(e.currentTarget.hash))
        }), $('a[href="#"]').on("click", function(e) {
            e.preventDefault()
        })
    }, $(theme.init), $(document).ready(function() {
        "use strict";
        $(document).on("click", ".currencyOpt", function(e) {
            $("#CurrencySelector").val($(this).data("value")), $("#localization_form").submit()
        }), $(".saleTime, .heroSaleTime, .prcountdown").each(function() {
            var e = $(this),
                t = $(this).data("date"),
                i = new Date(t).getTime(),
                n = setInterval(function() {
                    var t = (new Date).getTime(),
                        s = i - t,
                        a = Math.floor(s / 864e5),
                        o = Math.floor(s % 864e5 / 36e5),
                        r = Math.floor(s % 36e5 / 6e4),
                        c = Math.floor(s % 6e4 / 1e3);
                    a = ("00" + a).substr(a > 99 ? -3 : -2), o = ("00" + o).substr(-2), r = ("00" + r).substr(-2), c = ("00" + c).substr(-2), $(e).html("<span class='days'>" + a + "<span>" + theme.days + "</span></span> <span class='hours'>" + o + "<span>" + theme.hours + "</span></span> <span class='minutes'>" + r + "<span>" + theme.minuts + "</span></span> <span class='seconds'>" + c + "<span>" + theme.seconds + "</span>"), s < 0 && (clearInterval(n), $(e).hide(), $("#countdownLbl").hide())
                }, 1e3)
        }), $(".btn-shop").click(function() {
            $(".products .list-columns, .grid-lookbook").removeClass("active"), $(this).next().addClass("active"), $(this).parents(".grid-lookbook").addClass("active")
        }), $(".btn-shop-close").click(function() {
            $(this).parent().removeClass("active")
        }), "true" == $.cookie("promotion") && $(".notification-bar").slideUp(), $(".close-announcement").click(function() {
            $(".notification-bar").slideUp(), $.cookie("promotion", "true", {
                expires: 1,
                path: "/"
            })
        }), $(document).on("click touch", ".btn-filter, .closeFilter", function() {
            $(".filterbar").toggleClass("active")
        }), $("body").click(function(e) {
            var t = $(e.target);
            t.parents().is(".sb_filter") || t.is(".sb_filter") || t.is(".btn-filter") || $(".sb_filter").removeClass("active")
        }), window.onscroll = function() {
            ! function() {
                theme.fixedHeader && ($(window).scrollTop() > 145 ? ($("#header").addClass("stickyHeader animated fadeInDown"), $(".stickySpace").css("min-height", $("#header").height())) : ($("#header").removeClass("stickyHeader fadeInDown"), $(".stickySpace").css("min-height", "")));
                $(window).scrollTop() > 600 && $(".stickyCart").length ? ($("body.template-product").css("padding-bottom", "70px"), $(".stickyCart").slideDown(),$("body.template-product").addClass('stickyCart-active')) : ($("body.template-product").css("padding-bottom", "0"), $(".stickyCart").slideUp(),$("body.template-product").removeClass('stickyCart-active'));
                $(window).scrollTop() > 200 ? $("#site-scroll").fadeIn() : $("#site-scroll").fadeOut()
            }()
        }, $("#site-scroll").click(function() {
            return $("html, body").animate({
                scrollTop: 0
            }, 1e3), !1
        }), $(".footer-links .h4").click(function() {
            $(window).width() < 750 && ($(this).toggleClass("active"), $(this).next().slideToggle())
        }), $(".qtyBtn").on("click", function() {
            var e = $(this).parent(".qtyField"),
                t = $(e).find(".qty").val(),
                i = 1;
            $(this).is(".plus") ? i = parseInt(t) + 1 : t > 1 && (i = parseInt(t) - 1), $(e).find(".qty").val(i)
        }), $(document).on("click", ".gridSwatches li:not(.noImg)", function(e) {
            var t = $(this),
                i = $(this).attr("rel"),
                n = $(this).parents(".grid-view-item").find(".grid-view-item__link");
            $(n).addClass("showLoading"), $(n).find(".variantImg").css("background-image", "url('" + i + "')");
            var s = document.createElement("img");
            return s.src = i, s.onload = function() {
                $(n).removeClass("showLoading").addClass("showVariantImg"), t.siblings().removeClass("active"), t.addClass("active")
            }, !1
        })
    });